"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPlusCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M3.515 3.516c4.686-4.688 12.284-4.688 16.97 0 4.687 4.685 4.687 12.283 0 16.97-4.686 4.686-12.284 4.686-16.97 0-4.687-4.687-4.687-12.285 0-16.97zm15.886 1.083c-4.087-4.09-10.715-4.09-14.802 0-4.09 4.087-4.09 10.715 0 14.803 4.087 4.088 10.715 4.088 14.802 0 4.09-4.088 4.09-10.716 0-14.803zm-7.4 1.529c.387 0 .707.288.758.662l.007.104v4.339h4.34a.766.766 0 01.104 1.526l-.104.007-4.34-.001v4.341a.766.766 0 01-1.525.104l-.007-.104v-4.341h-4.34a.766.766 0 01-.104-1.524l.104-.007 4.34-.001v-4.34c0-.422.343-.765.766-.765z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgPlusCircle;
exports.default = _default;